<h2 mat-dialog-title>Version History - {{ data.scheduleName }}</h2>

<mat-dialog-content class="version-panel-content">
  @let versions = versionListData.items$ | async;
  @let loading = versionListData.isLoading$ | async;

  <ng-container *ngIf="loading; else contentTemplate">
    <div class="loading-container">
      <mat-spinner diameter="40"></mat-spinner>
    </div>
  </ng-container>

  <ng-template #contentTemplate>
    <ng-container *ngIf="versions?.length === 0; else versionListTemplate">
      <div class="empty-state">
        <mat-icon>history</mat-icon>
        <p>No versions found for this schedule.</p>
      </div>
    </ng-container>
  </ng-template>

  <ng-template #versionListTemplate>
    <div class="version-list">
    <!-- Bulk actions bar -->
    <div class="bulk-actions" *ngIf="selectedVersionIds.size > 0">
      <span class="selection-count">{{ selectedVersionIds.size }} selected</span>
      <button mat-button color="warn" (click)="deleteSelectedVersions()" [disabled]="deletingVersionIds.size > 0">
        <mat-icon>delete</mat-icon>
        Delete Selected
      </button>
      <button mat-button (click)="clearSelection()">
        Clear Selection
      </button>
    </div>

    <!-- Select all non-active -->
    <div class="select-actions" *ngIf="versions && versions.length > 1">
      <button mat-button (click)="selectAllNonActive()" [disabled]="selectedVersionIds.size > 0">
        <mat-icon>select_all</mat-icon>
        Select All Non-Active
      </button>
    </div>

    <!-- Version cards -->
    <div class="version-card" *ngFor="let version of versions"
         [class.active]="version.isActive"
         [class.selected]="selectedVersionIds.has(version.id)"
         [class.deleting]="deletingVersionIds.has(version.id)">

      <!-- Checkbox for selection (only for non-active versions) -->
      <div class="version-checkbox" *ngIf="!version.isActive">
        <mat-checkbox
          [checked]="selectedVersionIds.has(version.id)"
          (change)="toggleSelection(version.id)"
          [disabled]="deletingVersionIds.has(version.id)">
        </mat-checkbox>
      </div>
      <div class="version-checkbox placeholder" *ngIf="version.isActive"></div>

      <!-- Version info -->
      <div class="version-info">
        <div class="version-header">
          <span class="version-number">v{{ version.versionNumber }}</span>
          <span class="version-name" *ngIf="version.name">{{ version.name }}</span>
          <span class="active-badge" *ngIf="version.isActive">
            <mat-icon>check_circle</mat-icon>
            Active
          </span>
          <span class="lambda-deleted-badge" *ngIf="version.lambdaDeleted">
            <mat-icon>cloud_off</mat-icon>
            Lambda Deleted
          </span>
        </div>

        <div class="version-meta">
          <span class="created-date">
            <mat-icon>schedule</mat-icon>
            {{ versionHelper.formatDate(version.createdAt) }}
          </span>
          <span class="summary" *ngIf="version.summary">
            <mat-icon>analytics</mat-icon>
            {{ version.summary }}
          </span>
        </div>

        <!-- Note section -->
        <div class="version-note" *ngIf="editingNoteId !== version.id">
          <div class="note-content" *ngIf="version.note">
            <mat-icon>note</mat-icon>
            <span [matTooltip]="version.note">{{ version.note }}</span>
          </div>
          <button mat-icon-button
                  (click)="startEditNote(version)"
                  [matTooltip]="version.note ? 'Edit note' : 'Add note'"
                  class="edit-note-btn">
            <mat-icon>{{ version.note ? 'edit' : 'add_comment' }}</mat-icon>
          </button>
        </div>

        <!-- Note editing -->
        <div class="note-edit" *ngIf="editingNoteId === version.id" [formGroup]="noteFormGroup">
          <mat-form-field appearance="outline" class="note-field">
            <mat-label>Note</mat-label>
            <textarea matInput
                      formControlName="note"
                      rows="2"
                      placeholder="Add a note for this version..."></textarea>
          </mat-form-field>
          <div class="note-actions">
            <button mat-button (click)="cancelEditNote()">Cancel</button>
            <button mat-flat-button color="primary" (click)="saveNote(version)">Save</button>
          </div>
        </div>
      </div>

      <!-- Version actions -->
      <div class="version-actions">
        <button mat-icon-button
                *ngIf="!version.isActive"
                (click)="revertToVersion(version)"
                [disabled]="revertingVersionId === version.id || deletingVersionIds.has(version.id)"
                matTooltip="Set as active version">
          <mat-icon *ngIf="revertingVersionId !== version.id">restore</mat-icon>
          <mat-spinner *ngIf="revertingVersionId === version.id" diameter="20"></mat-spinner>
        </button>

        <button mat-icon-button
                color="warn"
                *ngIf="!version.isActive"
                (click)="deleteVersion(version)"
                [disabled]="deletingVersionIds.has(version.id)"
                matTooltip="Delete this version">
          <mat-icon *ngIf="!deletingVersionIds.has(version.id)">delete</mat-icon>
          <mat-spinner *ngIf="deletingVersionIds.has(version.id)" diameter="20"></mat-spinner>
        </button>
      </div>
    </div>
    </div>
  </ng-template>
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button mat-button mat-dialog-close>Close</button>
</mat-dialog-actions>
